import { useDataAssuranceDashboard } from "../../api/dashboard";
import ContentContainer from "../ContentContainer";
import EvidenceSection from "./EvidenceSection";
import EmissionFactorsSection from "./EmissionFactorsSection";
import { useEffect } from "react";
import ReportingScopeSection from "./ReportingScopeSection";
import CertaintySection from "./CertaintySection";

const AssuranceDashboard = () => {
    const { isLoading, assuranceDashboardData } = useDataAssuranceDashboard();

    // Remember scroll y
    useEffect(() => {
        const saveScrollPosition = () => {
            sessionStorage.setItem(
                "assurance-dashboard-scroll-y",
                window.scrollY.toString()
            );
        };

        window.addEventListener("mousedown", saveScrollPosition);

        const scrollY = sessionStorage.getItem("assurance-dashboard-scroll-y");

        if (scrollY !== null) {
            setTimeout(() => {
                window.scrollTo(window.scrollX, parseFloat(scrollY));
            }, 500);

            sessionStorage.removeItem("assurance-dashboard-scroll-y");
        }

        return () => {
            window.removeEventListener("mousedown", saveScrollPosition);
        };
    }, []);

    if (isLoading || !assuranceDashboardData) {
        return (
            <ContentContainer className="py-10 text-center">
                Loading...
            </ContentContainer>
        );
    }

    const totalEmissionsSourcesCount =
        assuranceDashboardData.notMaterialEmissionsSourcesCount +
        assuranceDashboardData.measuredPrimaryEmissionsSourcesCount +
        assuranceDashboardData.measuredSecondaryEmissionsSourcesCount +
        assuranceDashboardData.estimatedEmissionsSourcesCount +
        assuranceDashboardData.omittedEmissionsSourcesCount;

    if (totalEmissionsSourcesCount === 0) {
        return (
            <ContentContainer className="space-y-8 mb-6">
                <p className="text-center">
                    You have no data yet. Please add your first emissions source
                    in order to see data here.
                </p>
            </ContentContainer>
        );
    }

    return (
        <ContentContainer className="space-y-8 mb-6">
            <ReportingScopeSection
                notMaterialEmissionsSourcesCount={
                    assuranceDashboardData.notMaterialEmissionsSourcesCount
                }
                omittedEmissionsSourcesCount={
                    assuranceDashboardData.omittedEmissionsSourcesCount
                }
                estimatedEmissionsSourcesCount={
                    assuranceDashboardData.estimatedEmissionsSourcesCount
                }
                measuredSecondaryEmissionsSourcesCount={
                    assuranceDashboardData.measuredSecondaryEmissionsSourcesCount
                }
                measuredPrimaryEmissionsSourcesCount={
                    assuranceDashboardData.measuredPrimaryEmissionsSourcesCount
                }
            />
            <CertaintySection
                measuredEmissionsSourcesByRegion={
                    assuranceDashboardData.measuredEmissionsSourcesByRegion
                }
                notMeasuredEmissionsSourcesByRegion={
                    assuranceDashboardData.notMeasuredEmissionsSourcesByRegion
                }
            />
            <EvidenceSection
                evidenceMissingCount={
                    assuranceDashboardData.organizationEvidenceMissingCount
                }
                evidenceExpiringInNext30DaysCount={
                    assuranceDashboardData.organizationEvidenceExpiringInNext30DaysCount
                }
                evidenceInDateCount={
                    assuranceDashboardData.organizationEvidenceInDateCount
                }
                dataSourceEvidenceByRegion={
                    assuranceDashboardData.emissionsSourceEvidenceByRegion
                }
            />
            <EmissionFactorsSection
                activityDataPointsTotalCount={
                    assuranceDashboardData.activityDataPointsTotalCount
                }
                dataSourcesTotalCount={
                    assuranceDashboardData.dataSourcesTotalCount
                }
                activityDataPointsWithNoEmissionsFactorCount={
                    assuranceDashboardData.activityDataPointsWithNoEmissionsFactorCount
                }
                dataSourcesWithNoEmissionsFactorCount={
                    assuranceDashboardData.dataSourcesWithNoEmissionsFactorCount
                }
            />
        </ContentContainer>
    );
};

export default AssuranceDashboard;
